webpackJsonp([102898282630784],{

/***/ 869:
/***/ (function(module, exports) {

	module.exports = {"data":{"themenJson":{"thema":"then & now","monat_num":8,"thema_cover_uri":"08_2006.jpg","jahr":2006,"monat":"August","id":"thema_54","issue_date":"200608","moving_image_count":2,"still_image_count":4,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"thema_54"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200608-65b2387e8a7b2425cd3f.js